"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getOptimizedUrl;
var _isSvgUrl = _interopRequireDefault(require("./isSvgUrl"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function getOptimizedUrl(url, dimension, size, quality, disableRetina, supportsWebp) {
  if (!(0, _isSvgUrl.default)(url)) {
    let format = '';
    if (supportsWebp) {
      format = 'fm=webp';
    } else if (url.match(/\.jpe?g$/i)) {
      format = 'fm=jpg&fl=progressive';
    }
    let optimizedUrl = `${url}?${dimension}=${size}&q=${quality}&${format}`;
    if (!disableRetina) {
      optimizedUrl += `, ${url}?${dimension}=${size * 2}&q=${quality}&${format} 2x`;
    }
    return optimizedUrl;
  }
  return url;
}